module.exports = __webpack_public_path__ + "static/media/sud_add.a75eb23e.png";